import { render } from "./TermsAndPrivacyContentInline.vue.ts?vue&type=template&id=e99c682e&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentInline.vue?vue&type=template&id=e99c682e&scoped=true&ts=true"
import script from "./TermsAndPrivacyContentInline.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentInline.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndPrivacyContentInline.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentInline.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndPrivacyContentInline.vue.scss?vue&type=style&index=0&id=e99c682e&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentInline.vue?vue&type=style&index=0&id=e99c682e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99c682e"],['__file',"src/apps/merchant3/components/customer-registration/terms-and-privacy/TermsAndPrivacyContentInline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e99c682e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e99c682e', __exports__)) {
    api.reload('e99c682e', __exports__)
  }
  
  module.hot.accept("./TermsAndPrivacyContentInline.vue.ts?vue&type=template&id=e99c682e&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentInline.vue?vue&type=template&id=e99c682e&scoped=true&ts=true", () => {
    api.rerender('e99c682e', render)
  })

}


export default __exports__